query GetAssetDeviceCheckSummary {
  assetDeviceCheckSummary {
    computersInUse
    computersConfirmedInRmm
    appleDevices
    appleDevicesInAbm
    computersDueCheck
  }
}
